import { useEffect, useState } from 'react';

const useViewModel = () => {
  const [loadingPercentage, setLoadingPercentage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingPercentage((oldValue) => {
        const newLoadingPercentage = oldValue + 1;

        if (newLoadingPercentage === 90) {
          clearInterval(interval);
        }

        return newLoadingPercentage;
      });
    }, 100);
  }, []);

  useEffect(() => {
    const water = document.getElementById('water');
    if (water) {
      water.style.transform = `translate(0,${100 - loadingPercentage}%)`;
    }
  }, [loadingPercentage]);

  return;
};

export default useViewModel;
